module.exports = __webpack_public_path__ + "img/pro_seven_3.f88dc5b1.jpg";